export default "__VITE_ASSET__BnwI_AOI__"